<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="users"
        :server-items-length="totalUsers"
        :loading="usersLoading"
        hide-default-footer
        :multi-sort="false"
        :must-sort="true"
        @page-count="pageCount = $event"
        :page.sync="page"
        :options.sync="options"
        :items-per-page="itemsPerPage"
        :footer-props="{showFirstLastPage: true}"
        class="ic-table elevation-0 ic-table--heavy-headers"
      >
        <template v-slot:top>
          <v-container fluid class="white header-container">
            <v-row align="center" dense justify="space-between">
              <v-col cols="12" lg="8" class="v-toolbar__title">
                {{ $t("pages.user.list.title") }}
              </v-col>

              <v-col cols="10" lg="3">
                <v-text-field
                  v-model="dynamicSearch"
                  append-icon="$icons_system_search"
                  :label="$t('pages.user.list.search')"
                  single-line
                  clearable
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="2" lg="1">
                <v-btn
                  color="primary"
                  block
                  class="header-list-button"
                  @click="addUserClick()"
                >
                      <span class="hidden-sm-and-down">{{
                        $t("pages.user.list.addLink")
                      }}</span>
                  <v-icon class="hidden-md-and-up">$icons_system_plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <div class="header-separator"></div>
        </template>
        <template v-slot:header.givenName="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.familyName="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.email="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.action="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2 icon-control-list" @click="editItem(item)">$icons_system_edit</v-icon>
          <v-dialog :key="item.id" v-model="deleteDialogs[item.id]" :internal-activator="true" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-icon class="icon-control-list" small v-on="on">$icons_system_delete</v-icon>
            </template>
            <v-card>
              <v-card-title class="headline">{{$t('pages.user.deleteDialog.title')}}</v-card-title>
              <v-card-text>{{$t('pages.user.deleteDialog.text', { name: item.email })}}</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" text @click="$set(deleteDialogs, item.id, false)">{{$t('pages.user.deleteDialog.cancel')}}</v-btn>
                <v-btn color="primary" text @click="deleteItem(item)">{{$t('pages.user.deleteDialog.confirm')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
      <div class="text-center pt-8">
        <v-pagination v-model="page" :length="pageCount" total-visible="10"></v-pagination>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import debounce from 'debounce';

export default {
  name: 'UserList',
  props: {
    usersLoading: {
      type: Boolean,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    totalUsers: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      screenName: 'user-list',
      dynamicSearch: '',
      options: {},
      deleteDialogs: {},
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loading: false,
    };
  },
  created() {
    this.debouncedLoad = debounce(this.load, 500);
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
    totalUsers() {
      this.options.pageCount = Math.round(this.totalUsers / this.itemsPerPage) + 1;
    },
    dynamicSearch() {
      this.page = 1;
      this.debouncedLoad();
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('pages.user.list.givenName'),
          align: 'left',
          sortable: true,
          value: 'givenName',
        },
        {
          text: this.$t('pages.user.list.familyName'),
          align: 'left',
          sortable: true,
          value: 'familyName',
        },
        {
          text: this.$t('pages.user.list.email'),
          align: 'left',
          sortable: true,
          value: 'email',
        },
        {
          text: '',
          value: 'action',
          width: '10%',
          sortable: false,
          align: 'end',
        },
      ];
    },
  },
  methods: {
    addUserClick() {
      this.$emit('addUserClick');
    },

    async load() {
      const {
        page, itemsPerPage, sortBy, sortDesc,
      } = this.options;
      const sort = sortBy[0] || 'givenName,familyName';
      this.$emit('loadData', {
        page: page - 1,
        dynamicSearch: this.dynamicSearch,
        maxPerPage: itemsPerPage,
        sort: sortDesc[0] ? `-${sort}` : sort,
      });
    },

    editItem(item) {
      this.$emit('editUserClick', item);
    },
    deleteItem(item) {
      this.$emit('deleteUserClick', item);
    },
  },
};
</script>

<style scoped>
</style>
